import styled              from 'styled-components/macro'
import { Map }             from 'components/Map/Map'
import { useBreak } from 'hooks/useBreak';
import { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';
import mediaLoaderWhite from "../assets/animation-json/white.json"
export const ViewMap = ({ showTooltip, hideTooltip }) => {

  const isMobile        = useBreak('md_dn');
  
    const [isLottieVisible, setLottieVisible] = useState(true); // Controls visibility of the Lottie animation
  const inactivityTimer = useRef(null); // Ref to track inactivity timer
  const lottieTimer = useRef(null); // Ref to control Lottie visibility duration

  const handleLottieClick = () => {
    setLottieVisible(false); // Hide Lottie animation
    clearTimeout(lottieTimer.current); // Clear any active Lottie visibility timer
  };

  // Reset inactivity timer on user activity
  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer.current); // Clear previous inactivity timer

    // Set a new inactivity timer
    inactivityTimer.current = setTimeout(() => {
      // Show Lottie after 30 seconds of inactivity
      setLottieVisible(true);

      // Hide Lottie automatically after 10 seconds
      lottieTimer.current = setTimeout(() => setLottieVisible(false), 10000);
    }, 30000); // 30 seconds
  };

  useEffect(() => {
    // Show Lottie for 10 seconds initially
    lottieTimer.current = setTimeout(() => setLottieVisible(false), 10000);

    // Start the inactivity timer after the initial 10 seconds
    inactivityTimer.current = setTimeout(resetInactivityTimer, 10000);

    // Cleanup timers
    return () => {
      clearTimeout(inactivityTimer.current);
      clearTimeout(lottieTimer.current);
    };
  }, []);

  useEffect(() => {
    // List of events to detect user activity
    const activityEvents = ["mousemove", "keydown", "mousedown", "touchstart"];

    // Add event listeners
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetInactivityTimer),
    );

    // Start inactivity timer initially
    resetInactivityTimer();

    // Cleanup event listeners and timers on component unmount
    return () => {
      clearTimeout(inactivityTimer.current);
      clearTimeout(lottieTimer.current);
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetInactivityTimer),
      );
    };
  }, []);
  return (
    <>
      {/* <AnimatePresence> */}
        <Container>
          <Map showTooltip={showTooltip} hideTooltip={hideTooltip}/>
             {isLottieVisible && isMobile && (
                      <div
                        style={{
                          position: "absolute",
                          top: "23%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          zIndex: 5,
                          pointerEvents: "none", // let clicks pass through by default
                        }}
                      >
                        
                        <Lottie
                          animationData={mediaLoaderWhite}
                          loop={true}
                          style={{ width: "50vh", height: "35vh" }}
                        />
                        <div
                          onClick={handleLottieClick}
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "150px",
                            height: "90px",
                            cursor: "pointer",
                            pointerEvents: "auto", // only this small area accepts clicks
                          }}
                        />
                      </div>
                    )}
        </Container>
        {/* <div style={{border:'10px solid orange',height:100,width:'100%'}}></div>  */}
      {/* </AnimatePresence> */}
    </>
  )
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  ::-webkit-scrollbar { display: none; }
`